import { useContext } from "react";
import ClientContext, { IClientContextProps } from "./ClientContext";

const useClient: () => IClientContextProps = () => {
  return useContext(ClientContext);
};

export default useClient;